import { useTranslations } from "@/contexts/Translation";
import List from "@/components/List/List";
import { useUserManagement } from "./UserManagementContext";
import UserItem from "./UserItem";
import Collapsable from "@/components/Collapsable/Collapsable";
import Card from "@/components/Card/Card";
import styles from "./UserSection.module.css";

const UserSection = () => {
  const t = useTranslations("userManagementForm");
  const { orgUsers } = useUserManagement();

  return (
    <Card className={styles.card} padding='none' variant='collapsable'>
      <Collapsable toggleItem={t("title")} closed={false}>
        {orgUsers && (
          <List
            items={orgUsers.map((u) => (
              <UserItem key={u.userId} {...u} />
            ))}
          />
        )}
      </Collapsable>
    </Card>
  );
};

export default UserSection;
